import { ReactComponent as Arrow } from "assets/icons/arrow.svg";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const Container = styled.div`
  display: flex;
  border: 2px solid ${({ theme }) => theme.colors.primary};
  padding: 20px;
  min-height: 100px;
  cursor: pointer;

  :hover .arrow {
    transform: translateX(-25px) rotate(-90deg);
  }
`;

export const ResponsiveContainer = styled.div`
  display: flex;
  flex: 1;

  @media (max-width: ${breakpoints.sm}) {
    flex-direction: column;
  }
`;

export const StyledImage = styled.img`
  width: 20%;
  height: 100px;
  margin: auto;
  object-fit: contain;

  @media (max-width: ${breakpoints.sm}) {
    width: unset;
    height: 100px;
  }
`;

export const TextContainer = styled.div`
  flex: 1;
  margin: 0 30px;

  @media (max-width: ${breakpoints.sm}) {
    margin: 30px 0 0;
  }
`;

export const StyledArrow = styled(Arrow)`
  margin: auto 0;
  margin-left: 20px;
  min-width: 30px;
  transform: rotate(-90deg);
  transition: transform 0.15s;
`;
